<script>
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let title, message, dismissButtonLabel;
    export let show = false;
    export let disableActionButton = false;
    export let icon = 'fa fa-times';
    export let type = "confirm";
    export let actionButtonLabel = 'OK';
    export let center = false;
    export let hideFooter = false;
    export let forceHalf = false;


    let label;
    let currentState = 'idle';

    const design = {
        text:{
            warning:"text-red-900",
            confirm:"text-amber-900",
            delete:"text-amber-900",
            success:"text-green-900",
            edit:"text-green-900",
            add:"text-green-900",
        },
        bg:{
            warning:"bg-red-500",
            confirm:"bg-amber-500",
            delete:"bg-amber-500",
            success:"bg-green-500",
            edit:"bg-green-500",
            add:"bg-green-500",
        },
        hover:{
            warning:"hover:bg-red-700",
            confirm:"hover:bg-amber-700",
            delete:"hover:bg-amber-700",
            success:"hover:bg-green-700",
            edit:"hover:bg-green-700",
            add:"hover:bg-green-700",
        },
        icon: {
            warning:"fa-regular fa-triangle-exclamation",
            confirm:"fa-regular fa-hand",
            delete:"fa-regular fa-hand",
            success:"fa-solid fa-check",
            edit:"fa-solid fa-pen",
            add:"fa-regular fa-plus",
        }
    }



    function handleConfirm() {
        dispatch('confirm');
    }

    function handleDismiss() {
        dispatch('close');
    }

    $:currentState, actionButtonLabel, label = getLabel()

    export function state(state){
        currentState = state;
    }

    function getLabel(){
        switch (currentState) {
            case "waiting":
                return 'Please wait...';
            case "idle":
                return actionButtonLabel;
            default:
                return 'Click';
        }
    }
</script>

<style lang="scss">
    .modal {
      pointer-events: none;
      display:none;

      &.show {
        pointer-events: auto;
        display: block;
      }
      .half {
        @media screen and (min-width:1200px) {
          @apply right-0 left-1/2;
        }
      }
    }

</style>


<div class="modal relative z-40" aria-labelledby="modal-title" role="dialog" aria-modal="true" class:show>
    <div class="fixed right-0 inset-y-0 w-screen"></div>
    <div class="fixed z-10 overflow-y-auto inset-0" class:half={forceHalf}>
        <div class="flex min-h-full items-center justify-center p-4 text-center bg-gray-500 bg-opacity-75 transition-opacity sm:p-0">
            <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl sm:p-6">
                <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button on:click={handleDismiss} type="button" class="h-6 w-6 rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                        <span class="sr-only">Close</span>
                        <i class="fa-solid fa-x"></i>
                    </button>
                </div>
                <div class="sm:flex sm:items-start">
                    <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full {design.bg[type]} sm:mx-0 sm:h-10 sm:w-10">
                        <i class="text-lg {design.icon[type]} {design.text[type]}"></i>
                    </div>
                    <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" class:md:mx-auto={center}>
                        <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">{title || ''}</h3>
                        <div class="mt-2">
                            <slot name="message"></slot>
                        </div>
                    </div>
                </div>
                {#if !hideFooter}
                    <slot name="footer">
                        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                            <button
                                    on:click={handleConfirm}
                                    type="button"
                                    class="inline-flex w-full justify-center rounded-md {design.bg[type]} px-3 py-2 text-sm font-semibold text-white shadow-sm {design.hover[type]} sm:ml-3 sm:w-auto disabled:cursor-not-allowed"
                                    disabled={disableActionButton || currentState === 'waiting'}
                            >{label}</button>
                            <button
                                    on:click={handleDismiss}
                                    type="button"
                                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                    disabled={currentState === 'waiting'}
                            >{dismissButtonLabel || 'Cancel'}</button>
                        </div>
                    </slot>
                {/if}
            </div>
        </div>
    </div>
</div>
